import React from 'react';

import {Redirect} from 'react-router-dom'
import '../styling/DailyGameCard.css';
import PropTypes from 'prop-types'

class DailyGameCard extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			link: ""
		}
	}

	goToPage = (event, path) => {
		event.preventDefault();
		// this.setState({link: path})
	} 

    render = () => {
        return(
				<div className="DailyGameCard">
					<div className="DailyCards">
						<div className="card-cover" id="who-said"></div>
						<div className="card-text"><button onClick={event => this.goToPage(event, '/whoSaid')} className="daily-accent">#WhoSaidThat?</button></div>
					</div>
					<div className="DailyCards">
						<div className="card-cover" id="who-liked"></div>
						<div className="card-text"><button onClick={event => this.goToPage(event, '/play')} className="daily-accent">#WhoHasMoreFollowers?</button></div>
					</div>
					<div className="DailyCards">
						<div className="card-cover" id="who-follows"></div>
						<div className="card-text"><button className="daily-accent">#WhoLikedIt?</button></div>
					</div>
				</div>
        );
    }


}

DailyGameCard.propTypes = {
	gameChosen: PropTypes.func.isRequired
}


export default DailyGameCard;
